import { inject, observer } from 'mobx-react';
import { FunctionComponent } from 'react';

import { MobxInjectKey, PropsWithMobxStoreKey } from '@/mobx/types';

/**
 *
 * @description
 * @param {MobxInjectKey[]} storeList mobx状态列表 e.g. ['area','auth']
 * @param {FunctionComponent} Component 被注入injectKey的函数组件
 *
 * @example 携带props
 * const ChildWithProps = MobxWrap<PropsType,['app','auth']>(['app','auth'], (props) => {
 * const { isMobile } = props.app;
 * const { test } = props;
 * return ();
 * });
 *
 * @example 不携带props，直接使用
 * const ChildWithProps = MobxWrap(['app','auth'], () => {
 * const { isMobile } = props.app;
 * return ();
 * });
 */
const MobxWrap = <
  O extends Record<PropertyKey, unknown> = Record<PropertyKey, unknown>,
  T extends MobxInjectKey[] = MobxInjectKey[]
>(
  storeList: T,
  Component: FunctionComponent<PropsWithMobxStoreKey<T> & O>
) => {
  const WrappedComponent: FunctionComponent<PropsWithMobxStoreKey<T> & O> = inject(...storeList)(observer(Component));
  return WrappedComponent as FunctionComponent<O>;
};

/**
 *
 * @description 不含observer的mobxwrap，用法一致
 * @param {MobxInjectKey[]} storeList mobx状态列表 e.g. ['area','auth']
 * @param {FunctionComponent} Component 被注入injectKey的函数组件
 */
export const MobxInjectWrap = <
  O extends Record<PropertyKey, unknown> = Record<PropertyKey, unknown>,
  T extends MobxInjectKey[] = MobxInjectKey[]
>(
  storeList: T,
  Component: FunctionComponent<PropsWithMobxStoreKey<T> & O>
) => {
  const WrappedComponent: FunctionComponent<PropsWithMobxStoreKey<T> & O> = inject(...storeList)(Component);
  return WrappedComponent as FunctionComponent<O>;
};

export default MobxWrap;
